import { triggerStateChangedRequest } from '~core';
import { getState } from '~src/state';
import { clearSelectionsStyles } from '~src/utils';
import { updateTextBorderColorControl } from './updateTextBorderColorControl';
import { updateTextBorderThicknessControl } from './updateTextBorderThicknessControl';

export function removeTextBorder() {
  const activeObject = getState('activeObject');

  if (activeObject.isEditing) {
    const { selectionStart, selectionEnd } = activeObject;

    if (
      activeObject.text &&
      selectionStart === 0 &&
      selectionEnd === activeObject.text.length
    ) {
      clearSelectionsStyles(activeObject, 'stroke');
      clearSelectionsStyles(activeObject, 'strokeWidth');
      activeObject.set('stroke', null);
      activeObject.set('strokeWidth', 0);
    } else if (selectionStart === selectionEnd) {
      activeObject.set('stroke', null);
      activeObject.set('strokeWidth', 0);
    } else {
      activeObject.setSelectionStyles({
        stroke: null,
        strokeWidth: 0,
      });
    }
  } else {
    clearSelectionsStyles(activeObject, 'stroke');
    clearSelectionsStyles(activeObject, 'strokeWidth');
    activeObject.set('stroke', null);
    activeObject.set('strokeWidth', 0);
  }

  window.canvas.renderAll();
  updateTextBorderColorControl();
  updateTextBorderThicknessControl();
  triggerStateChangedRequest();
}
